import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/screenshot.svg'
import _imports_1 from '@/assets/zoom-to-fit.svg'
import _imports_2 from '@/assets/zoom-in.svg'
import _imports_3 from '@/assets/zoom-out.svg'


const _withScopeId = n => (_pushScopeId("data-v-634ee32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content d-flex flex-grow-1" }
const _hoisted_2 = { class: "main-window flex-grow-1" }
const _hoisted_3 = {
  key: 0,
  class: "controls"
}
const _hoisted_4 = { class: "zoom-buttons" }
const _hoisted_5 = { class: "screenshot-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import PotreeViewer from "@/components/Viewer/PotreeViewer.vue";
import { Splitpanes, Pane } from "splitpanes";
import AppHeader from "@/components/Pages/AppHeader.vue";
import Toolbar from "@/components/Viewer/Toolbar.vue";
import Layers from "../components/Viewer/Layers.vue";
import SelectionDetail from "@/components/Viewer/SelectionDetail.vue";
import { onMounted, onUnmounted, reactive, ref, watch, nextTick } from "vue";
import ViewControls from "@/components/Controls/ViewControls.vue";
import SplitButton from "@/components/Controls/SplitButton.vue";
import MapButton from "@/components/Controls/MapButton.vue";
import ProfileViewer from "@/components/Viewer/ProfileViewer.vue";
import NavigationTutorial from "@/components/Viewer/NavigationTutorial.vue";
// import ProfileViewerProperties from "@/components/Viewer/ProfileViewerProperties.vue";
import { useAppStateStore } from "@/store/app-state";
import { ViewIndex } from "@/classes/data-structures/view-index";
import DefaultLayout from "@/views/layouts/DefaultLayout.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const appState = useAppStateStore();

let data = reactive({
	sidebarOpen: false,
});
const viewer = ref();
const profileViewer = ref();
const isExternalImageViewerOpen = ref(false);
const navigationTutorial = ref<InstanceType<typeof NavigationTutorial>>();

// Reactive reference for profile pane size based on vertical exaggeration
const profilePaneSize = ref(30); // Default size as percentage

// Computed property to track ProfileViewer visibility
const isProfileViewerVisible = computed(() => {
	const sel = appState.selectedElement;
	if (!sel) return false;

	// Check if it's a Profile instance by checking for Profile-specific properties
	const isProfile = typeof sel === "object" && "chartPoints" in sel && Array.isArray((sel as any).chartPoints);

	return isProfile ||
		(sel as any).isMultiProfileSelection ||
		(sel as any).isProfileGroup;
});

function deleteSelectedElement() {
	viewer.value.deleteObject(appState.selectedElement);
}

function onKeyUp(e){
	//On delete pressed delete element
	if(e.keyCode == 46){
		deleteSelectedElement();
	}
}

function toggleLayers(){
	data.sidebarOpen = !data.sidebarOpen;
}

function createScreenshot(){
	var canvas:HTMLCanvasElement = document.getElementsByTagName("canvas")[0];
	var dataUrl = canvas.toDataURL("image/jpeg");
	
	let saveLink = document.createElement("a");
	saveLink.download = appState.project.name + ".jpeg";
	saveLink.href = dataUrl;
	saveLink.click();
}

// Handle vertical exaggeration changes to resize the profile pane
function onVerticalExaggerationChanged(event: CustomEvent) {
	if (event.detail && typeof event.detail.exaggeration === "number") {
		const exaggeration = event.detail.exaggeration;
		// Direct multiplication: 1x = 30%, 2x = 60%, 3x = 90%
		const baseSize = 30;
		const maxSize = 90; // Allow up to 90% for 3x
		
		// Simple direct scaling
		const newSize = Math.min(maxSize, baseSize * exaggeration);
		profilePaneSize.value = newSize;
	}
}

onMounted(()=>{
	window.addEventListener("keyup",onKeyUp);
	document.addEventListener("profile-vertical-exaggeration-changed", onVerticalExaggerationChanged as any);
	
	// Watch for ProfileViewer visibility changes and resize the main viewer accordingly
	watch(isProfileViewerVisible, (newValue, oldValue) => {
		if (newValue !== oldValue) {
			// Reset profile pane size to default when ProfileViewer becomes visible
			if (newValue) {
				profilePaneSize.value = 30; // Reset to default size when opening
			}
			
			// Use nextTick and a small delay to wait for the DOM and Splitpanes to update before resizing
			nextTick(() => {
				setTimeout(() => {
					if (viewer.value && viewer.value.getViewer && typeof viewer.value.getViewer().handleResize === "function") {
						viewer.value.getViewer().handleResize();
					}
				}, 100); // Small delay to allow Splitpanes animation to complete
			});
		}
	});
})

onUnmounted(()=>{
	window.removeEventListener("keyup",onKeyUp);
	document.removeEventListener("profile-vertical-exaggeration-changed", onVerticalExaggerationChanged as any);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { class: "viewer page d-flex flex-column" }, {
    default: _withCtx(() => [
      _createVNode(AppHeader, {
        "show-project": true,
        "show-survey": true,
        "show-edit-project-button": true,
        "show-share-button": true
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Toolbar, {
          onOpenNavigationTutorial: _cache[0] || (_cache[0] = ($event: any) => (navigationTutorial.value?.show()))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Splitpanes), {
            horizontal: "",
            class: "main-splitpanes",
            "push-other-panes": false
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Pane), { class: "viewer-pane" }, {
                default: _withCtx(() => [
                  _createVNode(PotreeViewer, {
                    ref_key: "viewer",
                    ref: viewer,
                    "view-index": _unref(ViewIndex).View1,
                    onExternalImageViewerOpenChanged: _cache[1] || (_cache[1] = ($event: any) => (isExternalImageViewerOpen.value = $event))
                  }, null, 8, ["view-index"]),
                  (_unref(appState).view1Survey && !isExternalImageViewerOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => {$event.preventDefault(); createScreenshot()}),
                              title: "Create screenshot"
                            })
                          ]),
                          _createElementVNode("div", {
                            class: "zoom-button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (viewer.value.zoomToFit()))
                          }, _hoisted_7),
                          _createElementVNode("div", {
                            class: "zoom-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (viewer.value.zoomIn()))
                          }, _hoisted_9),
                          _createElementVNode("div", {
                            class: "zoom-button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (viewer.value.zoomOut()))
                          }, _hoisted_11)
                        ]),
                        _createVNode(ViewControls, { class: "view-type-toggle" }),
                        _createVNode(MapButton, { class: "map-button" }),
                        _createVNode(SplitButton, { class: "split-button" })
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(appState).view1Survey)
                    ? (_openBlock(), _createBlock(NavigationTutorial, {
                        key: 1,
                        ref_key: "navigationTutorial",
                        ref: navigationTutorial
                      }, null, 512))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_unref(isProfileViewerVisible))
                ? (_openBlock(), _createBlock(_unref(Pane), {
                    key: 0,
                    class: "profile-pane",
                    size: profilePaneSize.value,
                    "min-size": 20,
                    "max-size": 90
                  }, {
                    default: _withCtx(() => [
                      (_unref(appState).view1Survey)
                        ? (_openBlock(), _createBlock(ProfileViewer, {
                            key: 0,
                            ref_key: "profileViewer",
                            ref: profileViewer,
                            class: "profile-viewer-window",
                            viewer: viewer.value
                          }, null, 8, ["viewer"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["size"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["sidebar-menu", [_unref(data).sidebarOpen ? 'open' : 'closed']])
        }, [
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleLayers())),
            class: "layers-menu-button"
          }),
          _createVNode(_unref(Splitpanes), {
            horizontal: "",
            class: "default-theme",
            "push-oher-panes": false
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Pane), {
                size: "70",
                class: "sidebar"
              }, {
                default: _withCtx(() => [
                  _createVNode(SelectionDetail, { onOnSelectedElementDeleted: deleteSelectedElement })
                ]),
                _: 1
              }),
              _createVNode(_unref(Pane), { class: "sidebar" }, {
                default: _withCtx(() => [
                  _createVNode(Layers, {
                    "view-index": _unref(ViewIndex).View1
                  }, null, 8, ["view-index"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})